export const PLACEMENTS_HORIZ = ['left', 'right'];
export const PLACEMENTS_VERT = ['top', 'bottom'];
export const PLACEMENTS_SIDES = [...PLACEMENTS_HORIZ, ...PLACEMENTS_VERT];
export const PLACEMENTS = [...PLACEMENTS_SIDES, 'left top', 'left bottom', 'right top', 'right bottom', 'top left', 'top right', 'bottom left', 'bottom right'];
export const FLOATING_UI_PLACEMENTS_MAP = {
  top: 'top',
  'top left': 'top-end',
  'top right': 'top-start',
  right: 'right',
  'right top': 'right-end',
  'right bottom': 'right-start',
  bottom: 'bottom',
  'bottom left': 'bottom-end',
  'bottom right': 'bottom-start',
  left: 'left',
  'left top': 'left-end',
  'left bottom': 'left-start'
};
export const PLACEMENTS_FLOATING_UI_MAP = {
  top: 'top',
  'top-start': 'top right',
  'top-end': 'top left',
  right: 'right',
  'right-start': 'right bottom',
  'right-end': 'right top',
  bottom: 'bottom',
  'bottom-start': 'bottom right',
  'bottom-end': 'bottom left',
  left: 'left',
  'left-start': 'left bottom',
  'left-end': 'left top'
};